/*
 * @Author: Chao Yang
 * @Date: 2019-10-08 06:44:30
 * @LastEditor: Chao Yang
 * @LastEditTime: 2019-10-17 12:25:23
 */
import { MenuItem } from './menu-item';
export class MenuOption {
  constructor() {
    this.menus = [];
  }
  public branding: string;
  public menus: MenuItem[];
}
